import React, { useState, useEffect } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { getDatabase, ref, remove, get, update } from 'firebase/database';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';
import fc from '../firebaseConfig';

const db = getDatabase(fc);

const fetchClients = async () => {
  const clientsRef = ref(db, 'clients');
  const snapshot = await get(clientsRef);
  const clients = [];
  if (snapshot.exists()) {
    snapshot.forEach((childSnapshot) => {
      clients.push({ id: childSnapshot.key, ...childSnapshot.val() });
    });
  }
  return clients;
};

const deleteClient = async (clientId) => {
  const clientRef = ref(db, `clients/${clientId}`);
  await remove(clientRef);
};

const updateClient = async (clientId, updatedData) => {
  const clientRef = ref(db, `clients/${clientId}`);
  await update(clientRef, updatedData);
};

const TableClients = () => {
  const [clients, setClients] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [editClient, setEditClient] = useState({ name: '', number: '', description: '' });
  const [errors, setErrors] = useState({ name: false, number: false, description: false });
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      if (!localStorage.getItem('LOGGED_IN')) {
        navigate('/');
      }
    };

    checkAuth();

    const getClients = async () => {
      const clientsList = await fetchClients();
      setClients(clientsList);
    };

    getClients();
  }, [navigate]);

  const handleClickOpenDelete = (clientId) => {
    setSelectedClientId(clientId);
    setOpenDelete(true);
  };

  const handleClickOpenEdit = (client) => {
    setSelectedClientId(client.id);
    setEditClient({ name: client.name, number: client.number, description: client.description });
    setErrors({ name: false, number: false, description: false });
    setOpenEdit(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedClientId(null);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSelectedClientId(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedClientId) {
      await deleteClient(selectedClientId);
      const clientsList = await fetchClients();
      setClients(clientsList);
      handleCloseDelete();
    }
  };

  const handleSaveEdit = async () => {
    const { name, number, description } = editClient;

    if (!name || !number || !description) {
      setErrors({
        name: !name,
        number: !number,
        description: !description,
      });
      return;
    }

    if (selectedClientId) {
      await updateClient(selectedClientId, editClient);
      const clientsList = await fetchClients();
      setClients(clientsList);
      handleCloseEdit();
    }
  };

  const handleShowMore = (clientId) => {
    navigate(`/client/${clientId}`);
  };

  return (
    <div>
      <Navbar />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto', flexDirection: 'column', marginTop: '3rem'}}>
        <TableContainer component={Paper} style={{ maxWidth: '800px', marginTop: '20px', marginBottom: '10rem' }}>
          <h2 style={{ marginLeft: '15px' }} className='header'>Tabela Klientów</h2>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Imię i Nazwisko</TableCell>
                <TableCell>Numer</TableCell>
                <TableCell>Opis</TableCell>
                <TableCell>Akcje</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clients.map((client) => (
                <TableRow key={client.id}>
                  <TableCell>{client.name}</TableCell>
                  <TableCell>{client.number}</TableCell>
                  <TableCell>{client.description}</TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      color='warning'
                      onClick={() => handleShowMore(client.id)}
                      style={{ marginRight: '10px' }}
                    >
                      Więcej
                    </Button>
                    <Button
                      variant="outlined"
                      color='primary'
                      onClick={() => handleClickOpenEdit(client)}
                      sx={{marginRight: "10px"}}
                    >
                      Edytuj
                    </Button>
                    <Button
                      variant="outlined"
                      color='error'
                      onClick={() => handleClickOpenDelete(client.id)}
                    >
                      Usuń
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Confirmation Dialog for Delete */}
        <Dialog open={openDelete} onClose={handleCloseDelete}>
          <DialogTitle>Potwierdzenie Usunięcia</DialogTitle>
          <DialogContent>
            Czy na pewno chcesz usunąć tego klienta?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDelete} color="primary">
              Anuluj
            </Button>
            <Button onClick={handleConfirmDelete} color='error'>
              Usuń
            </Button>
          </DialogActions>
        </Dialog>

        {/* Edit Dialog */}
        <Dialog open={openEdit} onClose={handleCloseEdit}>
          <DialogTitle>Edytuj Klienta</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Imię i Nazwisko"
              fullWidth
              value={editClient.name}
              onChange={(e) => setEditClient({ ...editClient, name: e.target.value })}
              error={errors.name}
              helperText={errors.name ? "Pole nie może być puste" : ""}
            />
            <TextField
              margin="dense"
              label="Numer"
              fullWidth
              value={editClient.number}
              onChange={(e) => setEditClient({ ...editClient, number: e.target.value })}
              error={errors.number}
              helperText={errors.number ? "Pole nie może być puste" : ""}
            />
            <TextField
              margin="dense"
              label="Opis"
              fullWidth
              value={editClient.description}
              onChange={(e) => setEditClient({ ...editClient, description: e.target.value })}
              error={errors.description}
              helperText={errors.description ? "Pole nie może być puste" : ""}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEdit} color="primary">
              Anuluj
            </Button>
            <Button onClick={handleSaveEdit} color='primary'>
              Zapisz
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default TableClients;
